import { theme, rem } from '@nobia/zeus-components/lib/styled'

export default {
  colors: {
    text: '#0B0A07',
    black: '#0B0A07',
    white: '#ffffff',
  },
  headerContainer: {
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  grid: {
    containerMaxWidth: '1808px',
  },

  mainContainer: {
    alignItems: 'left',
    athenaPaddingTablet: '96px',
    athenaPaddingDesktop: '104px',
  },
  typography: {
    mobileImageLabel: {
      fontSize: rem(30),
      fontWeight: '200',
    },
    pageTitle: {
      fontSize: '46px',
      fontSizeDesktop: '82px',
      letterSpacing: '-1.5px',
      letterSpacingDesktop: '-1.5px',
      lineHeight: '56px',
      lineHeightDesktop: '86px',
      textTransform: 'none',
      fontWeight: '100',
      color: theme('colors.text'),
      maxWidth: '100%',
      maxWidthDesktop: '100%',
    },
    pageDescription: {
      fontSize: '16px',
      fontSizeDesktop: '18px !important',
      fontWeight: '300',
      letterSpacing: '-0.6px',
      letterSpacingDesktop: '-0.6px',
      lineHeight: '24px',
      lineHeightDesktop: '28px',
      color: theme('colors.text'),
      maxWidth: '100%',
      maxWidthDesktop: '1040px',
    },
    collectionLabel: {
      fontSize: '32px',
      fontWeight: '300',
      letterSpacing: '0',
    },
    imageLabelText: {
      fontSize: rem(14),
      fontWeight: '500',
      textTransform: 'uppercase',
      letterSpacing: '2.63px',
      color: theme('colors.white'),
    },
    modalHeadline: {
      fontSizeDesktop: rem(18),
      fontSize: rem(18),
      color: '#fff',
      fontWeight: '300',
    },
    modalText: {
      fontSize: rem(16),
    },
    numberOfImages: {
      fontSize: rem(16),
      lineHeight: '31px',
      color: '#fff',
      fontWeight: '300',
    },
  },
  backgroundElement: {},
  collectionWrapper: {
    top: `calc(100vh - 79px) !important`,
    height: `79px`,
    backgroundColor: 'rgba(0,0,0, 0.35)',
    width: `100%`,
    flexDirection: 'row',
    alignItems: 'center',
    labelAnimationFrom: {
      marginLeft: '0',
      opacity: 0,
    },
    labelAnimationTo: {
      marginLeft: '0',
      opacity: 1,
    },
  },
  numberOfImages: {
    top: `calc(100vh - 48px) !important`,
    position: 'relative',
    margin: '0 0 0 7px',
    marginDesktop: '0 0 0 102px',
    height: '22px',
  },
  styledLink: {
    border: '0.5px solid #C19A5B',
    borderWidth: '0 0 1px 0',
    marginRight: '76px',
    marginRightDesktop: '172px',
    textAlign: 'center',
    padding: '0',
    color: '#fff',
    fontWeight: '300',
  },
  collectionLabel: {
    margin: '0 0 0 7px',
    marginDesktop: '0 0 0 102px',
    lineHeight: '34px',
    bottom: '100px',
    letterSpacing: '-0.6px',
  },
  row: {
    athenaPaddingTablet: '78px',
    athenaPaddingDesktop: '86px',
  },
  filter: {
    header: {
      textAlign: 'left',
    },
    row: {
      align: 'left',
    },
    column: {
      color: theme('colors.text'),
      margin: '30px 40px 20px 0',
      marginDesktop: '30px 40px 20px 0',
    },
    label: {
      fontWeight: '300',
      marginBottom: '10px',
      display: 'inline-block',
      letterSpacing: '-0.6px',
    },
    icon: {
      position: '-4px',
    },
    button: {
      radius: '0',
      fontSize: '14px',
      fontWeight: '500',
      padding: '12px 44px 13px 33px',
      border: '1.5px solid #c19a5b',
      textTransform: 'uppercase',
      letterSpacing: '2.63px',
      hover: {
        background: 'transparent',
        opacity: '0.72',
      },
    },
    type: {
      fontSize: '14px',
      textTransform: 'uppercase',
      letterSpacing: '3.5px',
      marginBottom: '20px',
    },
  },
  image: {
    ImageLabel: {
      backgroundColor: 'transparent',
      borderRadius: 0,
      height: '50px',
      padding: '12px 30px 13px',
      border: '1.5px solid #c19a5b',
    },
    StyledIcon: {
      display: 'none',
    },

    thumbnail: {
      transition: 'all 0.3s ease-in-out',
      filter: 'brightness(100%)',
      width: '100%',
      hover: {
        filter: 'brightness(60%)',
      },
    },
  },
}
